import * as React from 'react'
import { Box, Icon, Typography, Divider, styled } from '@design/pt-ui'
import { Contact } from '../interfaces/entities/contact'
import { translateWithUserLocale } from '../utils/i18n'

const ContactInfoText = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
})

interface ContactsProps {
  contacts: Contact[]
  message: string
}

const Contacts = (props: ContactsProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        marginTop: '25px',
        flexFlow: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Box component="h2" sx={{ p: 3, color: 'black' }}>
        {translateWithUserLocale('send_creatives_dialog.thank_you_note')}
      </Box>
      <Box sx={{ p: 3, pt: 0 }}>
        <Divider />
        <Typography
          sx={{ fontWeight: 300, paddingRight: '15px' }}
          variant="body1">
          {props.message}
        </Typography>
        {props.contacts.map((contact) => (
          <div key={contact.id}>
            <ContactInfoText variant="caption">{contact.role}</ContactInfoText>
            {contact.name ? (
              <ContactInfoText variant="body1" color="secondary">
                {contact.name}
              </ContactInfoText>
            ) : (
              ''
            )}

            {contact.phone ? (
              <ContactInfoText variant="body1">
                <Icon>phone</Icon>
                {contact.phone}
              </ContactInfoText>
            ) : (
              ''
            )}

            {contact.email ? (
              <ContactInfoText variant="subtitle1">
                <Icon>alternate_email</Icon>
                {contact.email}
              </ContactInfoText>
            ) : (
              ''
            )}

            <Divider />
          </div>
        ))}
      </Box>
    </Box>
  )
}

export default Contacts
